import { useState } from 'react';
import { createJobCharge } from '../api/jobCharges';
import type { CreateJobChargeRequest, JobCharge } from '../types/jobCharge';

/**
 * Hook for creating a new job charge
 */
export function useCreateJobCharge() {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (
    jobId: number,
    data: CreateJobChargeRequest
  ): Promise<JobCharge | null> => {
    setIsCreating(true);
    setError(null);
    try {
      const charge = await createJobCharge(jobId, data);
      return charge;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to create job charge');
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return {
    create,
    isCreating,
    error,
  };
}
